












import Vue from 'vue';
import BuiltInListLock from '@/components/configuration/listMaintenance/BuiltInListLock.vue';
import MaintainBuiltInListItems from '@/components/configuration/listMaintenance/MaintainBuiltInListItems.vue';
import { ListMaintenanceService } from '@/services/ListMaintenanceService';
import { Configuration, ErrorModel, LockModel, StoreConstants } from '@/types';
import { mapActions, mapGetters } from 'vuex';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import ErrorNotification from '@/components/shared/ErrorNotification.vue';
import store from '@/store';

export default Vue.extend({
  name: 'BuiltInListItems',
  props: {},
  data() {
    return {
      isLoading: true,
      lastActivity: new Date()
    };
  },
  computed: {
    ...mapGetters(StoreConstants.ListMaintenance.ModuleName, [StoreConstants.ListMaintenance.Getters.EntityLock, StoreConstants.ListMaintenance.Getters.Error]),
    ...mapGetters('applicationDirtyStore', ['isApplicationDirty']),
    hasListLock(this: any) {
      return !this.isLoading && this[StoreConstants.ListMaintenance.Getters.EntityLock];
    },
    validLock(this: any) {
      return (this[StoreConstants.ListMaintenance.Getters.EntityLock] as LockModel)?.isLocked && (this[StoreConstants.ListMaintenance.Getters.EntityLock] as LockModel)?.isLockedByCurrentSessionId;
    },
    errorModel(this: any) {
      if (this.hasListLock && !this.validLock) {
        return {
          buttonRouteName: Configuration.ListMaintenance.ListMaintenance.name,
          buttonText: 'Return to Lists',
          header: 'Sorry',
          icon: 'lock',
          iconTheme: 'text-secondary',
          showButton: true,
          showHeader: true,
          message: (this[StoreConstants.ListMaintenance.Getters.EntityLock] as LockModel).lockMessage
        } as ErrorModel;
      }
      const storeError = this[StoreConstants.ListMaintenance.Getters.Error];
      return Object.keys(storeError).length ? storeError : null;
    }
  },
  methods: {
    ...mapActions(StoreConstants.ListMaintenance.ModuleName, [
      StoreConstants.ListMaintenance.Actions.SetEntityLock,
      StoreConstants.ListMaintenance.Actions.ReleaseBuiltInListLock,
      StoreConstants.ListMaintenance.Actions.SetErrorModel
    ])
  },
  async mounted(this: any) {
    const lock = await ListMaintenanceService.getBuiltInListLockAsync(Number(this.$route.params.listId));
    this[StoreConstants.ListMaintenance.Actions.SetEntityLock](lock);
    this.isLoading = false;
  },
  async beforeRouteLeave(this: any, to, from, next) {
    if (!this.isApplicationDirty) {
      await this[StoreConstants.ListMaintenance.Actions.ReleaseBuiltInListLock]();
      this[StoreConstants.ListMaintenance.Actions.SetErrorModel]({});
      next();
    } else {
      store.dispatch('applicationDirtyStore/setApplicationDirtyRouteNavigatedTo', to);
      store.dispatch('applicationDirtyStore/setShowApplicationDirtyModal', true);
      next(false);
    }
  },
  components: { BuiltInListLock, MaintainBuiltInListItems, LoadingSpinner, ErrorNotification }
});
